export const FETCH_DATA_REQUEST = 'location-picker/FETCH_DATA_REQUEST' as const;
export const FETCH_DATA_SUCCESS = 'location-picker/FETCH_DATA_SUCCESS' as const;
export const FETCH_DATA_FAILURE = 'location-picker/FETCH_DATA_FAILURE' as const;
export const SET_CONTEXT = 'location-picker/SET_CONTEXT' as const;
export const CANCEL_DIALOG = 'location-picker/CANCEL_DIALOG' as const;
